// @flow
import React from 'react';
import Modal from 'react-modal';
import SimpleBar from 'simplebar-react';
import { useViewport } from 'components/templates/viewportProvider';
import chevronRightIcon from 'assets/images/rightb.png';
import './styles.scss';

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  filterContent: Component,
};

export const FiltersModal = (props: Props) => {
  const { isMobile } = useViewport();
  const { isOpen, onClosePress, filterContent } = props;

  const onClose = () => {
    onClosePress();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`filters-overlay-content ${isMobile ? 'mobile' : ''}`}
    >
      <div className={'filters-modal'}>
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronRightIcon} alt={'icon'} />
        </a>
        {!isMobile && <span className={'modal-title'}>Filters</span>}
        <SimpleBar autoHide={false} style={{ height: '100%' }}>
          <div className={'filters-content'}>
            <div className={'filters-header'}>
              <h3>Looking for something specific?</h3>
              {!isMobile && (
                <p>
                  Lorem ipsum our professional expertise with cutting-edge
                  technology and an out-of-the-box approach dolor sit amet.
                </p>
              )}
            </div>
            <div className={'filter-set'}>{filterContent}</div>
          </div>
        </SimpleBar>
      </div>
    </Modal>
  );
};
